import { useLazyQuery } from "@apollo/client/react";import React, { useEffect, useState } from 'react';
import './imprimirMinutaGrilla.scss';
import { CustomButton } from '../../../components/customButton/CustomButton';
import toast from 'react-hot-toast';
import { GET_IMPRIMIR_MINUTA_DOCUMENTO } from '../../../data/graphQL/queries/ImprimirMinuta/getImprimirMinutaDocumento';

import fileDownload from 'js-file-download';

export const ImprimirMinutaGrillaHeader = ({
  allowedWrite,
  minutasSeleccionadas,
  setPrintLoading
}) => {
  const [numeroFacturaPrint, setNumeroFacturaPrint] = useState('');

  const [getPrintDocumento, { data: docData, loading: printDocumentoLoading }] = useLazyQuery(GET_IMPRIMIR_MINUTA_DOCUMENTO, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!docData) return;
    if (docData.imprimirMinutaDocumento.success) {
      const arr = new Uint8Array(docData.imprimirMinutaDocumento.valorEsperado);
      const documento = new Blob([arr], { type: 'application/pdf' });
      const fileName = 'NumFact-' + numeroFacturaPrint + '.pdf';
      fileDownload(documento, fileName);
    } else {
      toast.error("No fue posible generar el documento.");
    }
    setPrintLoading(false);
  }, [docData]);

  const getIdsMinutas = (listaMinutas) => {
    let listaIds = [];
    if (listaMinutas.length > 0) {
      listaMinutas.map((nodo) => {
        listaIds.push(nodo.idMinuta);
      });
    }
    return listaIds;
  };

  const printValid = () => {
    if (minutasSeleccionadas.length == 0) {
      toast.error("Debe seleccionar al menos un registro para imprimir.");
      return false;
    }
    // solo se pueden imprimir minutas de una determinada factura
    const factura = minutasSeleccionadas[0].numeroFactura;
    if (minutasSeleccionadas.filter((f) => f.numeroFactura != factura).length > 0) {
      toast.error("Solo se puede imprimir de forma agrupada las minutas que poseen el mismo número de factura.");
      return false;
    }

    setNumeroFacturaPrint(factura);
    return true;
  };

  const handleImprimir = () => {
    if (printValid() && !printDocumentoLoading) {
      setPrintLoading(true);
      // se ordenan las minutas por orden alfabetico del paciente
      const minutasOrdenadas = [...minutasSeleccionadas].sort((a, b) =>
        a.paciente.localeCompare(b.paciente)
      );

      getPrintDocumento({ variables: { minutas: getIdsMinutas(minutasOrdenadas) } });
    }
  };

  return (
    <>
        <div className='top-buttons'>
            <CustomButton
          isLoading={printDocumentoLoading}
          disabled={
          !allowedWrite ||
          minutasSeleccionadas == null || minutasSeleccionadas.length == 0
          }
          onClick={handleImprimir}
          variant="outlined">
          
                Imprimir
            </CustomButton>
        </div>
        </>);

};